import { defineMessages } from 'react-intl'

export default defineMessages({
  departmentsAccessHeader: {
    id: 'purchasing.assignDepartmentsToUser.view.departmentsAccessHeader',
    defaultMessage: 'Departments access',
  },
  selectAll: {
    id: 'purchasing.assignDepartmentsToUser.view.selectAll',
    defaultMessage: 'Select all',
  },
  deselectAll: {
    id: 'purchasing.assignDepartmentsToUser.view.deselectAll',
    defaultMessage: 'Deselect all',
  },
  save: {
    id: 'purchasing.assignDepartmentsToUser.view.save',
    defaultMessage: 'Save',
  },
  cancel: {
    id: 'purchasing.assignDepartmentsToUser.view.cancel',
    defaultMessage: 'Cancel',
  },
  emptyState: {
    id: 'purchasing.assignDepartmentsToUser.view.emptyState',
    defaultMessage: 'No departments available.',
  },
})
